<template>
  <el-dialog class="k-start-edit-form" :title="marathon && marathon._id ? `Редагування старта ${marathon._id}` : 'Створення нового старта'" :visible="dialogFormVisible" @close="handleCancel">
    <div class="k-start-edit-form__container">
      <p class="k-start-edit-form__title">Ви можете відредагувати інформацію про старт. Та зберегти її у базі даних:</p>

      <el-row :gutter="20" class="k-start-edit-form__param">
        <el-col :span="8" class="k-start-edit-form__label">Назва старту:</el-col>
        <el-col :span="16"><el-input placeholder="Название" v-model="title"></el-input></el-col>
      </el-row>

      <el-row :gutter="20" class="k-start-edit-form__param">
        <el-col :span="8" class="k-start-edit-form__label">&nbsp;</el-col>
        <el-col :span="16"><el-checkbox v-model="active">Активный</el-checkbox></el-col>
      </el-row>

      <el-row :gutter="20" class="k-start-edit-form__param">
        <el-col :span="8" class="k-start-edit-form__label">Організатор</el-col>
        <el-col :span="8">
          <el-select v-model="organizer" placeholder="Select" :disabled="systemOrganizerChecked">
            <el-option
              label="Без організатора"
              :value="null"
            />
            <el-option
              v-for="item in startsOrganizers"
              :key="item._id"
              :label="item.title"
              :value="item._id"
            />
          </el-select>
        </el-col>
        <el-col :span="8" class="k-start-edit-form__switch">
          KindChallenge
          <el-switch v-model="systemOrganizerChecked"></el-switch>
        </el-col>
      </el-row>

      <el-row v-if="systemOrganizerChecked" :gutter="20" class="k-start-edit-form__param">
        <el-col :span="8" class="k-start-edit-form__label">Фонд</el-col>
        <el-col :span="16">
          <el-select v-model="foundation" multiple :default-first-option="true" placeholder="Select">
            <el-option
              v-for="item in foundations"
              :key="item._id"
              :label="item.title"
              :value="item._id"
            />
          </el-select>
        </el-col>
      </el-row>

      <el-row v-if="systemOrganizerChecked" :gutter="20" class="k-start-edit-form__param">
        <el-col :span="8" class="k-start-edit-form__label">Вартість</el-col>
        <el-col :span="16">
          <el-input-number v-model="price" :min="0" :step="10"></el-input-number>
        </el-col>
      </el-row>

      <el-row :gutter="20" class="k-start-edit-form__param">
        <el-col :span="8" class="k-start-edit-form__label">Город:</el-col>
        <el-col :span="16"><el-input placeholder="Город проведения" v-model="city"></el-input></el-col>
      </el-row>

      <el-row :gutter="20" class="k-start-edit-form__param">
        <el-col :span="8" class="k-start-edit-form__label">Дата старта:</el-col>
        <el-col :span="16">
          <el-date-picker
            v-model="date"
            type="datetime"
            placeholder="Дата старту">
          </el-date-picker>
        </el-col>
      </el-row>

      <el-row v-if="systemOrganizerChecked" :gutter="20" class="k-start-edit-form__param">
        <el-col :span="8" class="k-start-edit-form__label">Опис:</el-col>
        <el-col :span="16">
          <div class="k-start-edit-form__editor" ref="descriptionEditor">qweqwe</div>
        </el-col>
      </el-row>

      <el-row v-if="systemOrganizerChecked" :gutter="20" class="k-start-edit-form__param">
        <el-col :span="8" class="k-start-edit-form__label">Опис (банер):</el-col>
        <el-col :span="16">
          <div class="k-start-edit-form__editor" ref="descriptionBannerEditor">asdasdasd</div>
        </el-col>
      </el-row>

      <el-row :gutter="20" class="k-start-edit-form__param">
        <el-col :span="8" class="k-start-edit-form__label">Фото старта:</el-col>
        <el-col :span="16">
          <el-upload
            class="k-start-edit-form__upload"
            action=""
            :http-request="addAttachment"
            :file-list="attachments"
            :show-file-list="false">
            <el-button
              size="mini"
              type="primary"
              icon="el-icon-picture">Завантажити</el-button>
            <el-button
              type="danger"
              size="mini"
              plain
              :disabled="!previewPicture"
              icon="el-icon-document-delete"
              @click.stop="removePicture">Видалити</el-button>
            <div slot="tip" class="el-upload__tip">Розмiр не бiльше 5 мб</div>
          </el-upload>
          <img
            v-if="previewPicture"
            class="k-start-edit-form__upload-preview"
            :src="previewPicture"
            alt="">
        </el-col>
      </el-row>

      <el-row :gutter="20" class="k-start-edit-form__param">
        <!-- <el-col :span="8" class="k-start-edit-form__label">Категории фонда:</el-col> -->
        <el-col :span="24">
          <el-transfer
            class="k-start-edit-form__categories"
            filterable
            :filter-method="filterMethod"
            filter-placeholder="Найти категорию"
            :titles="['Не активные', 'Выбранные']"
            v-model="categories"
            :data="categoriesList"
          >
          </el-transfer>
        </el-col>
      </el-row>

      <el-row :gutter="20" class="k-start-edit-form__param">
        <el-col :span="8" class="k-start-edit-form__label">Веб сайт:</el-col>
        <el-col :span="16"><el-input placeholder="URL веб сайта" v-model="url"></el-input></el-col>
      </el-row>

      <el-row :gutter="20" class="k-start-edit-form__param">
        <el-button type="success" round @click="handleSave" size="mini">Сохранить</el-button>
        <el-button round @click="handleCancel" size="mini">Отмена</el-button>
      </el-row>
    </div>
  </el-dialog>
</template>

<script>
import { apiSetImagePreview } from '@/api';
import { encodeImage } from '@/util';
import { Auth } from 'aws-amplify';
import { mapGetters, mapActions } from 'vuex';
import Quill from 'quill';
import 'quill/dist/quill.snow.css';
/**
 * Component: k-start-edit-form - Форма для редактирования информации о токене
*
* @version 1.0.0
*/

const toStr = param => param ? param : '';
const toBool = param => param ? param : true;

export default {
  name: 'k-start-edit-form',

  props: {
    // Является ли форма видимой
    dialogFormVisible: {
      type: Boolean,
      required: true,
    },

    // Данные для отображения
    marathon: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      title: '',
      active: false,
      city: '',
      date: null,
      address: '',
      url: '',
      categories: [],
      organizer: null,
      foundation: null,
      attachments: [],
      previewPicture: '',
      description: '',
      descriptionBanner: '',
      price: 0,
      systemOrganizerChecked: false,
      descriptionEditor: null,
      descriptionBannerEditor: null,
    };
  },

  computed: {
    ...mapGetters({
      user: 'user/user',
      startsCategories: 'settings/startsCategories',
      startsOrganizers: 'starts/startsOrganizers',
      systemOrganizer: 'starts/systemOrganizer',
      foundations: 'foundations/foundations',
    }),
    categoriesList() {
      const data = [];
      this.startsCategories.forEach((category, index) => {
        data.push({
          label: category,
          key: index,
        });
      });
      return data;
    },
  },

  watch: {
    marathon: {
      handler: function(newValue) {
        this.setMarathonData();
      },
      deep: true,
    },
    systemOrganizerChecked(value) {
      if (value) {
        this.organizer = this.systemOrganizer._id;
        this.foundation = this.marathon.foundation
          ? this.marathon.foundation
          : this.foundations[0] && this.foundations[0]._id;
        this.initEditor();
      } else {
        this.organizer = null;
        this.foundation = null;
        this.price = 0;
      }
    },
  },

  async created() {
    await this.getAppSettings();
    await this.getFoundations({
      limit: 1000,
      offset: 0,
    });
    if (this.marathon) {
      this.setMarathonData();
    }
  },

  methods: {
    setMarathonData() {
      this.title = this.marathon.title ? this.marathon.title : '';
      this.city = this.marathon.city ? this.marathon.city : '';
      this.active = this.marathon.active ? this.marathon.active : false;
      this.organizer = this.marathon.organizer ? this.marathon.organizer : null;
      this.date = this.marathon.date ? this.marathon.date : null,
      this.url = this.marathon.url ? this.marathon.url : '';
      this.categories = this.marathon.categories ? this.marathon.categories.map(item => this.categoriesList.findIndex(category => category.label === item)).filter(item => item !== -1) : [];
      this.previewPicture = this.marathon.previewPicture ? this.marathon.previewPicture : '';
      this.price = this.marathon.price || 0;
      this.systemOrganizerChecked = this.marathon.ownStart || false;
      this.foundation = this.marathon.foundation || '';
    },

    initEditor() {
      this.$nextTick(() => {
        this.descriptionEditor = new Quill(this.$refs.descriptionEditor, {
          theme: 'snow',
        });
        this.descriptionBannerEditor = new Quill(this.$refs.descriptionBannerEditor, {
          theme: 'snow',
        });

        this.descriptionEditor.root.innerHTML = this.marathon.description || '';
        this.descriptionBannerEditor.root.innerHTML = this.marathon.descriptionBanner || '';

        this.descriptionEditor.on('text-change', () => {
          this.handleUserInput('descriptionEditor', 'description');
        });

        this.descriptionBannerEditor.on('text-change', () => {
          this.handleUserInput('descriptionBannerEditor', 'descriptionBanner');
        });
      });
    },

    handleUserInput(editor, key) {
      if (this[editor].getLength() > 1) {
        this[key] = this[editor].root.innerHTML;
      } else {
        this[key] = '';
      }
    },

    // Отмена редактирования токена
    handleCancel() {
      this.$emit('cancel');
    },

    // Сохранение информации о токене на бекенде
    async handleSave() {
      const marathon = {
        title: this.title,
        active: this.active,
        city: this.city,
        url: this.url,
        organizer: this.organizer,
        date: this.date,
        categories: this.categories.map(item => this.categoriesList[item].label),
        previewPicture: this.previewPicture,
        description: this.description,
        price: this.price,
        descriptionBanner: this.descriptionBanner,
        ownStart: this.systemOrganizerChecked,
        foundation: this.foundation,
      };

      if (this.marathon._id) {
        marathon._id = this.marathon._id;
      }

      await this.setMarathon(marathon);
      this.$emit('update');
    },

    filterMethod(query, item) {
      return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
    },

    removePicture() {
      this.previewPicture = '';
    },

    async addAttachment(files) {
      const userSession = await Auth.userSession(this.user);
      const image = await encodeImage(files.file);
      const maxSize = 5e+6; // 5mb

      if (files.file.size > maxSize) {
        this.$message({
          type: 'warning',
          message: 'Файл дуже великий. Будь ласка, добавьте фото меншого розмiру.',
        });
      } else {
        try {
          const imageHash = image.split(',')[1];
          const response = await apiSetImagePreview(userSession.accessToken.jwtToken, { image: imageHash });

          if (response.status === 200) {
            this.previewPicture = response.data.imageUrl;
          }
        } catch (e) {
          console.log(e);
        }
      }
    },

    ...mapActions({
      getAppSettings: 'settings/getAppSettings',
      setMarathon: 'marathons/setMarathon',
      getFoundations: 'foundations/getFoundations',
    }),
  },
};
</script>

<style lang="scss">
@import '~@/scss/styles';

.k-start-edit-form {
  $this: &;
  $icon-size: 50px;

  text-align: left;

  &__container {
    padding: 0 20px;
  }

  &__title {
    margin-bottom: 2 * $vp;
  }

  &__param {
    margin-bottom: $vp;
  }

  &__input {
    textarea {
      font-family: inherit;
    }
  }

  &__label {
    line-height: 40px;
    text-align: right;
    padding-right: $hp;
  }

  &__icon {
    width: $icon-size;
    height: $icon-size;
    margin: 10px auto;
    border-radius: $icon-size / 2;
    background-color: black;

    & svg {
      width: $icon-size;
      height: $icon-size;
    }
  }
  &__upload-preview {
    max-width: 100%;
    margin-top: $hp;
  }
  &__switch {
    line-height: 40px;

    .el-switch {
      margin-left: 10px;
    }
  }
  &__editor {
    min-height: 200px;
    max-height: 50vh;
    overflow: auto;
  }
}
</style>
